import React from "react";
import { Outlet } from "react-router-dom";
import Header from "../components/header";
import FooterV2 from "../components/FooterV2";
import { Auth } from "./Authentication";

function PublicFooter() {
  return (
    <>
      <Outlet />
      <FooterV2 />
    </>
  );
}

export default PublicFooter;
